import Common from '../Common/Constants'
import axios from 'axios'
import AddClub from "./AddClub"
import AlertModal from '../Common/AlertModal'
import ProgressDialog from '../Common/ProgressDialog'
import UploadStatusDialog from '../Common/UploadStatusDialog'
import Vue from 'vue'

export default {
    name: "MyClubs",
    components: {AddClub, AlertModal, ProgressDialog, UploadStatusDialog},
    data() {
        let self = this;
        return {
            constant: Common,
            loginOfficer: {},
            header: {},
            search: '',
            searchReq: '',
            delDialog: false,
            statusDialog: false, status: '', club_id: '',
            delData: {},
            headers: [
                {text: 'Name', align: '', sortable: true, value: 'club_name'},
                {text: 'Type', align: '', sortable: true, value: 'elc_type'},
                {text: 'Members', align: 'right', sortable: false, value: 'member_count'},
                {text: 'Member Request', align: 'right', sortable: false, value: 'member_count'},
                {text: 'ELC Code', align: '', sortable: false, value: 'elc_code'},
                {text: 'Booth', align: '', sortable: true, value: 'booth'},
                {text: 'Pincode', align: '', sortable: false, value: 'pincode'},
                {text: 'Area', align: '', sortable: true, value: 'area'},
                {text: 'Taluka', align: '', sortable: true, value: 'taluka'},
                {text: 'Registered in app', align: 'right', sortable: false, value: ''},
                {text: 'Status', align: '', sortable: false, value: ''},
                {text: 'Actions', sortable: false,},
            ],
            headersJoinReq: [
                {text: 'Name', align: '', sortable: true, value: 'club_name'},
                {text: 'Requested By', align: '', sortable: true, value: 'clubMember'},
                {text: 'Pincode', align: '', sortable: false, value: 'pincode'},
                {text: 'Area', align: '', sortable: true, value: 'area'},
                {text: 'Taluka', align: '', sortable: true, value: 'taluka'},
                {text: 'Actions', sortable: false,},
            ],
            headersView: [
                {text: 'Name', align: '', sortable: true, value: 'club_name'},
                {text: 'Type', align: '', sortable: true, value: 'elc_type'},
                {text: 'Members', align: 'right', sortable: false, value: 'member_count'},
                {text: 'Member Request', align: 'right', sortable: false, value: 'member_count'},
                {text: 'ELC Code', align: '', sortable: false, value: 'elc_code'},
                {text: 'Booth', align: '', sortable: true, value: 'booth'},
                {text: 'Pincode', align: '', sortable: false, value: 'pincode'},
                {text: 'Area', align: '', sortable: true, value: 'area'},
                {text: 'Taluka', align: '', sortable: true, value: 'taluka'},
                {text: 'Registered in app', align: 'right', sortable: false, value: ''},
                {text: 'Status', align: '', sortable: false, value: ''},
            ],
            elcType: ['Future Voter', 'New Voter', 'Chunav Pathshala', 'Voter Awareness Forum'],
            clubDetails: [],
            loading: true,
            successToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'success-toast'
            },
            errorToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'error-toast'
            },
            clubFileName: '',
            clubFile: '',
            dialog: false,
            title: '', description: '', valid: false, announcementDialog: false,
            fieldRules: [
                v => !!v || 'This field is required',
            ], an_club_id: '',
            bulkDelDialog: false,
            alertDialog: false,
            msg: '',
            reqSelected: [],
            selected: [],
            addClubDialog: false, editClubDialog: false, errorDialog: false, editClub: {},
            addFlag: false,
            detailData: [],
            detailsDialog: false,
            //    update
            mask: '##### #####',
            maskAlphaNum: 'NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN',
            roleOfficers: [],
            roleOfficers1: [],
            areaData: [],
            pinFlag: false,
            club1: {
                status: 1,
                club_id: '',
                elc_code: '',
                elc_type: '',
                longitude: '',
                latitude: '',
                club_name: '',
                pincode: '',
                area: '',
                taluka: '',
                booth: '',
                district: '',
                state: '',
                officers: [
                    {name: '', officer_id: '', role: '', phone: ''}
                    /*, {
                        role: '',
                        phone: '',
                        officer_id: '',
                        name: ''
                    }, {
                        role: '', name: '',
                        phone: '',
                        officer_id: ''
                    }*/
                ],

            },
            clubStatus: [
                {value: 0, name: 'Deactive'},
                {value: 1, name: 'Active'}
            ],
            nameRules: [
                v => !!v || 'This field is required',
                (v) => {
                    if (!v || v.length <= 3)
                        return 'Must be greater than 3 characters';
                    else return true;
                },
            ],
            elecIdRules: [
                v => !!v || 'Election id is required',
                (v) => {
                    if (!v || v.length < 10)
                        return 'Must be 10 characters';
                    else if (!v || v.length > 10)
                        return 'Must be 10 characters';
                    else return true;
                },
            ],
            pinCodeRules: [
                v => !!v || 'This field is required',
                (v) => {
                    if (!v || v.length >= 1 &&  v.length < 6 )
                        return 'Must be 6 characters';
                    else return true;
                }
            ],
            user: {},
            requestFlag: false,
            delReqDialog: false,
            uploadBtnFlag: false,
            clubReqDetails: [], isVerifyCount: '',
            uploadProgressPopup: false,
            uploadStatusPopup: false,
            successRecordArr: [],
            failRecordArr: [],
            bulkBtnValue: '',

            searchVal: '',
            skip: 0, count: 25,
            totalCount: 0, totalPage: '', page: 1,
            pagiReqSkip: 0, pagiReqCount: 25,
            totalClubReqCount: 0, totalReqPage: 0, reqPage: 1

        }
    },
    beforeRouteEnter(to, from, next) {
        next();
    },
    beforeRouteUpdate(to, from, next) {
        next();
        this.getClubDetails();
        // this.getOfficerDetails()
    },
    beforeRouteLeave(to, from, next) {
        next();
    },

    created() {
        let self = this;
        self.user = JSON.parse(localStorage.getItem('user'));
        let token = localStorage.getItem('token');
        if (token === '' || token === undefined || token === null) {
            self.$router.push('/')
        }
        self.header = {
            "Content-Type": "application/json",
            "token": token,
        };
        self.getClubDetails();
        self.getClubRequest();
        /*self.getClubCount();
        self.getClubRequestCount();*/
        Vue.prototype.$myClubFlag = true;
    },
    computed:
        {
            /*clubFilter: function () {
                let self = this;
                let result = self.clubDetails.filter(function (task) {
                    task.club_name = task.club_name === null ? '' : task.club_name;
                    task.elc_type_name = task.elc_type_name === null ? '' : task.elc_type_name;
                    task.elc_code = task.elc_code === null ? '' : task.elc_code;
                    task.booth = task.booth === null ? '' : task.booth;
                    task.pincode = task.pincode === null ? '' : task.pincode;
                    task.area = task.area === null ? '' : task.area;
                    task.taluka = task.taluka === null ? '' : task.taluka;
                    return (task.club_name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                        task.elc_type_name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                        task.elc_code.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                        task.booth.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                        task.pincode.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                        task.area.toLowerCase().indexOf(self.search.toLowerCase()) >= 0 ||
                        task.taluka.toLowerCase().indexOf(self.search.toLowerCase()) >= 0)
                });

                return result

            }*/
        },
    watch: {
        search: function (val) {
            this.searchVal = val;
            this.getClubDetails();
        },
        searchReq: function (val) {
            this.searchVal = val;
            this.getClubRequest();
        },
    },
    methods: {
        isAlphaNumeric: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            var ret = (charCode == 32 || (charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122));
            if (!ret) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        filter(roleOfficer, clubOfficer) {
            return roleOfficer.filter(function (roleOfficerObj) {
                return !clubOfficer.find(function (officerObj) {
                    return roleOfficerObj.officer_id === officerObj.nodal_officer_id
                })
            });
        },
        getOfficerDetails() {
            let self = this;
            let officerArr = [];
            self.user.name = (self.user.mname == null || self.user.mname == '') ? self.user.fname + ' ' + self.user.lname :
                self.user.name = self.user.fname + ' ' + self.user.mname + ' ' + self.user.lname;
            officerArr.push(self.user);
            self.roleOfficers.push(officerArr);
        },
        getEditOfficerDetails() {
            let self = this;
            let officerArr = [];
            self.user.name = (self.user.mname == null || self.user.mname == '') ? self.user.fname + ' ' + self.user.lname :
                self.user.name = self.user.fname + ' ' + self.user.mname + ' ' + self.user.lname;
            officerArr.push(self.user);
            self.roleOfficers1.push(officerArr);
        },
        openAnnouncementDelDialog(data) {
            let self = this;
            self.title = '';
            self.description = '';
            self.an_club_id = '';
            self.$refs.formAN.reset();
            self.an_club_id = data.club_id;
            self.announcementDialog = true;

        },
        cancelAnnoucementDialog() {
            let self = this;
            self.announcementDialog = false;
            self.title = '';
            self.description = '';
            self.an_club_id = '';
            self.$refs.formAN.reset();
        },
        addAnnoucement() {
            let self = this;
            self.announcementDialog = false;
            let request = {
                "club_id": self.an_club_id,
                'text': self.title,
                'description': self.description,
            };
            axios.post(self.constant.apiUrl + "create/announcement", request, {headers: self.header})
                .then(function (response) {
                    if (response.data.flag) {
                        self.$toasted.show('Announcement created', self.successToast);
                    }
                    else {
                        self.$toasted.show(response.data.message, self.errorToast);
                    }
                })

        },
        /*getClubDetails() {
            let self = this;
            let request = {};
            if (self.$route.params.district == 'district' && self.$route.params.club == 'club' && self.$route.params.taluka != 'taluka') {
                request = {
                    "filters":
                        {
                            'taluka': this.$route.params.taluka,
                        }
                };

            } else if (self.$route.params.taluka == 'taluka' && self.$route.params.club == 'club' && self.$route.params.district != 'district') {
                request = {
                    "filters":
                        {
                            'elc_type': this.$route.params.district
                        }
                };
            }
            else if (self.$route.params.district == 'district' && self.$route.params.taluka != 'taluka' && self.$route.params.club != 'club') {
                request = {
                    "filters":
                        {
                            'taluka': self.$route.params.taluka,
                            'elc_type': self.$route.params.club
                        }

                }
            }
            else {
                request = {
                    "filters": {}
                }
            }
            let arr = [];
            let arrReq = [];
            request.filters.nodal_officer_id = self.user.officer_id;
            axios.post(self.constant.apiUrl + 'club/filter', request, {headers: self.header})
                .then(res => {
                    if (res.data.flag) {
                        res.data.data.forEach(function (val) {
                            val.elc_type_name=self.constant.elc_type_const[val.elc_type];
                            if (val.status === 1) {
                                val.booleanStatus = true
                            } else {
                                val.booleanStatus = false
                            }
                            if (val.is_verify == 1) {
                                arr.push(val)
                            }
                            else {
                                arrReq.push(val)
                            }

                        });
                        self.clubDetails = arr;
                        self.clubReqDetails = arrReq;
                        self.isVerifyCount = self.clubReqDetails.length
                        self.getOfficerDetails();
                        self.loading = false;
                    }
                    else {
                        self.loading = false;
                        self.$toasted.show('Club Not Found', self.errorToast)
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    // self.$toasted.show(handle, self.errorToast);
                })

        },*/
        pagination(str) {
            let self = this;
            if (str == 'JoinReq') {
                self.pagiReqSkip = ((self.reqPage - 1) * self.pagiReqCount);
                self.getClubRequest();
            }
            else {
                self.skip = ((self.page - 1) * self.count);
                self.getClubDetails();
            }
        },
       /* getClubCount() {
            let self = this;
            axios.get(self.constant.apiUrl + 'club/count/allow', {headers: self.header})
                .then(res => {
                        if (res.data.flag) {
                            self.totalCount = res.data.data
                            self.getClubDetails();
                        }
                        else {
                            self.$toasted.show('Club Not Found', self.errorToast)
                        }
                    }
                )
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                })
        },
        getClubRequestCount() {
            let self = this;
            axios.get(self.constant.apiUrl + 'club/count/pending', {headers: self.header})
                .then(res => {
                        if (res.data.flag) {
                            self.totalClubReqCount = res.data.data;
                            self.getClubRequest();
                        }
                        else {
                            self.$toasted.show('Club Not Found', self.errorToast)
                        }
                    }
                )
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                })
        },*/
        getClubDetails() {
            let self = this;
            let request = {};
            if (self.$route.params.district == 'district' && self.$route.params.club == 'club' && self.$route.params.taluka != 'taluka') {
                request = {
                    "filters": {
                        "search": self.searchVal,
                        'taluka': this.$route.params.taluka,
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.skip,
                    "count": self.count
                };

            } else if (self.$route.params.taluka == 'taluka' && self.$route.params.club == 'club' && self.$route.params.district != 'district') {
                request = {
                    "filters": {
                        "search": self.searchVal,
                        'elc_type': this.$route.params.district
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.skip,
                    "count": self.count
                };
            }
            else if (self.$route.params.district == 'district' && self.$route.params.taluka != 'taluka' && self.$route.params.club != 'club') {
                request = {
                    "filters": {
                        "search": self.searchVal,
                        'taluka': self.$route.params.taluka,
                        'elc_type': self.$route.params.club
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.skip,
                    "count": self.count
                }
            }
            else {
                request = {
                    "filters": {
                        "search": self.searchVal
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.skip,
                    "count": self.count
                }
            }
            request.filters.nodal_officer_id = self.user.officer_id;
            if(self.search!='')
                request.skip=0
            let arr = [];
            let arrReq = [];
            axios.post(self.constant.apiUrl + 'club/filter/allow', request, {headers: self.header})
                .then(res => {
                        if (res.data.flag) {
                            res.data.data.club.forEach(function (val) {
                                val.elc_type_name = self.constant.elc_type_const[val.elc_type];
                                if (val.status === 1) {
                                    val.booleanStatus = true
                                } else {
                                    val.booleanStatus = false
                                }
                            });
                            self.clubDetails = res.data.data.club;
                            self.totalCount = res.data.data.count;
                            self.totalPage = Math.ceil(self.totalCount / self.count);
                            self.getOfficerDetails();
                            self.loading = false
                        }
                        else {
                            self.loading = false;
                            self.$toasted.show('Club Not Found', self.errorToast)
                        }
                    }
                )
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                })

        },
        getClubRequest() {
            let self = this;
            let request = {};
            if (self.$route.params.district == 'district' && self.$route.params.club == 'club' && self.$route.params.taluka != 'taluka') {
                request = {
                    "filters": {
                        "search": self.searchVal,
                        'taluka': this.$route.params.taluka,
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.pagiReqSkip,
                    "count": self.pagiReqCount
                };

            } else if (self.$route.params.taluka == 'taluka' && self.$route.params.club == 'club' && self.$route.params.district != 'district') {
                request = {
                    "filters": {
                        "search": self.searchVal,
                        'elc_type': this.$route.params.district
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.pagiReqSkip,
                    "count": self.pagiReqCount
                };
            }
            else if (self.$route.params.district == 'district' && self.$route.params.taluka != 'taluka' && self.$route.params.club != 'club') {
                request = {
                    "filters": {
                        "search": self.searchVal,
                        'taluka': self.$route.params.taluka,
                        'elc_type': self.$route.params.club
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.pagiReqSkip,
                    "count": self.pagiReqCount
                }
            }
            else {
                request = {
                    "filters": {
                        "search": self.searchVal
                    },
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": self.pagiReqSkip,
                    "count": self.pagiReqCount
                }
            }
            if(self.searchReq!='')
                request.skip=0
            let arr = [];
            let arrReq = [];
            axios.post(self.constant.apiUrl + 'club/filter/pending', request, {headers: self.header})
                .then(res => {
                        if (res.data.flag) {
                            res.data.data.club.forEach(function (val) {
                                val.elc_type_name = self.constant.elc_type_const[val.elc_type];
                                if (val.status === 1) {
                                    val.booleanStatus = true
                                } else {
                                    val.booleanStatus = false
                                }
                            });
                            self.clubReqDetails = res.data.data.club;
                            self.totalClubReqCount = res.data.data.count;
                            self.totalReqPage = Math.ceil(self.totalClubReqCount / self.pagiReqCount);
                            self.loading = false
                        }
                        else {
                            self.loading = false;
                            self.$toasted.show('Club Not Found', self.errorToast)
                        }
                    }
                )
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                })

        },
        openDelDialog(data) {
            let self = this;
            self.delDialog = true;
            self.delData = {};
            self.delData = data;
        },
        openDelReqDialog(data) {
            let self = this;
            self.delReqDialog = true;
            self.delData = {};
            self.delData = data;
        },
        openDetailDialog(data) {
            let self = this;
            self.club1 = data;
            self.club1.officers = data.officer_Data;
            self.detailsDialog = true;
        },
        deleteClub() {
            let self = this;
            let a = self.delData;
            const index = this.clubDetails.indexOf(a);
            let cid = this.clubDetails[index].club_id;
            axios.get(self.constant.apiUrl + 'club/delete/' + cid, {headers: self.header})
                .then(function (res) {
                    if (res.data.flag) {
                        self.$toasted.show('Club Deleted', self.successToast);
                        self.skip = self.clubDetails.length > 1 ? self.skip : self.skip - self.count;
                        self.getClubDetails();
                        // self.clubDetails.splice(index, 1);
                        self.getOfficerDetails();
                        self.$forceUpdate();
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                        // self.$toasted.show(res.data.message, self.errorToast);
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    // self.$toasted.show(handle, self.errorToast);
                });
            self.delDialog = false
        },
        deleteReqClub() {
            let self = this;
            let a = self.delData;
            const index = this.clubReqDetails.indexOf(a);
            let cid = this.clubReqDetails[index].club_id;
            axios.get(self.constant.apiUrl + 'club/delete/' + cid, {headers: self.header})
                .then(function (res) {
                    if (res.data.flag) {
                        self.$toasted.show('Club Deleted', self.successToast);
                        self.skip = self.clubReqDetails.length > 1 ? self.skip : self.skip - self.count;
                        self.getClubRequest();
                        // self.clubDetails.splice(index, 1);
                        self.getOfficerDetails();
                        self.$forceUpdate();
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                        // self.$toasted.show(res.data.message, self.errorToast);
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    // self.$toasted.show(handle, self.errorToast);
                });
            self.delReqDialog = false
        },
        openBulkDelDialog(str) {
            let self = this;
            self.bulkDelDialog = true;
            self.bulkBtnValue = str
        },
        bulkDelete() {
            let self = this;
            let clubIdArr = [];
            if (self.bulkBtnValue === 'Clubs') {
                self.selected.forEach(function (val) {
                    clubIdArr.push(val.club_id)
                });
            } else {
                self.reqSelected.forEach(function (val) {
                    clubIdArr.push(val.club_id)
                });
            }
            let request = {
                'clubIds': clubIdArr
            };
            axios.post(self.constant.apiUrl + 'club/bulkAction', request, {headers: self.header})
                .then(function (res) {
                    if (res.data.flag) {
                        self.selected = [];
                        self.$toasted.show('Club Deleted', self.successToast);
                        self.getClubDetails();
                        self.getClubRequest();
                        self.getOfficerDetails();
                        self.bulkDelDialog = false;
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                        // self.$toasted.show(res.data.message, self.errorToast);
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    // self.$toasted.show(handle, self.errorToast);
                });
        },
        redirectToAddNewClub() {
            let self = this;
            self.addFlag = true;
            self.addClubDialog = true
        },
        openNoOfficerDialog() {
            let self = this;
            self.alertDialog = true;
            self.msg = '';
            self.msg = "All nodal officers are assigned to club. So you cannot create club";
        },
        openEditDialog(data) {
            let self = this;
            self.club1 = data;
            self.club1.officers = [
                {
                    name: data.officer_Data[0].name.includes('  ') ? data.officer_Data[0].name.replace('  ', ' ') : data.officer_Data[0].name,
                    officer_id: data.officer_Data[0].officer_id,
                    role: data.officer_Data[0].role,
                    phone: data.officer_Data[0].phone
                }
            ];
            self.getEditOfficerDetails();
            self.requestFlag = false;
            self.editClubDialog = true;
        },
        openRequestDialog(data) {
            let self = this;
            self.openEditDialog(data);
            self.requestFlag = true;
        },
        getArea(data) {
            let self = this;
            if (data.length == 6) {
                axios.get(self.constant.apiUrl + 'getTerritory/' + data, {headers: self.header})
                    .then(res => {
                        if (res.data.flag) {
                            self.areaData = res.data.data;
                            self.club1.area = self.areaData.area;
                            self.club1.taluka = self.areaData.taluka;
                            // self.club.district = 'Arvalli';
                            self.pinFlag = true

                        } else {
                            self.club1.area = '';
                            self.club1.taluka = '';
                        }
                    })
            }
        },
        /*  getOfficer() {
              let arr = [];
              let self = this;
              let response = [];
              let tempRole = [];
              let a = ['0', '1', '2'];
              a.forEach(function (i) {
                  axios.get(self.constant.apiUrl + 'officer/get/officer/' + i, {headers: self.header})
                      .then(res => {
                          if (res.data.flag) {
                              res.data.data.forEach(function (val) {
                                  val.name = val.prefix + ' ' + val.fname + ' ' + val.mname + ' ' + val.lname;
                              });
                              response = res.data.data;
                              if (response[0].officer_role == 0) {
                                  tempRole[0] = response;
                              }
                              else if (response[0].officer_role == 1) {
                                  tempRole[1] = response;
                              }
                              else if (response[0].officer_role == 2) {
                                  tempRole[2] = response;
                              }
                              self.roleOfficers = tempRole;
                          } else {
                              self.$toasted.show(res.data.message, self.errorToast);
                          }
                      })
                      .catch((handle) => {
                          self.$toasted.show(handle, self.errorToast);
                      })
              });

          },*/
        updateClub() {
            let self = this;
            self.club1.is_verify = self.requestFlag ? 1 : self.club1.is_verify;
            self.club1.officers[0].role = 0;
            axios.post(self.constant.apiUrl + 'club/update', self.club1, {headers: self.header})
                .then(res => {
                    if (res.data.flag) {
                        self.requestFlag ? self.$toasted.show('Club Added', self.successToast)
                            : self.$toasted.show('Club Updated', self.successToast);
                        self.cancelEditClubDialog();
                        self.getClubDetails();
                        if (self.requestFlag)
                            self.getClubRequest();
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                        // self.$toasted.show(res.data.message, self.errorToast);
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = "Please fill valid details";
                    // self.$toasted.show(handle, self.errorToast);
                })
        },
        updateStatusDialog(id, status) {
            let self = this;
            self.statusDialog = true;
            self.club_id = id;
            self.status = status;
        },
        updateStatus(id, status) {
            let self = this;
            if (status == true) {
                status = 1
            } else if (status == false) {
                status = 0
            }
            let request = {
                club_id: id,
                status: status
                // status: self.constant.switch_constant[status]
            };
            axios.post(self.constant.apiUrl + 'club/update', request, {headers: self.header})
                .then(res => {
                    if (res.data.flag) {

                        res.data.data.status === 1 ? self.$toasted.show('Club Activated', {
                            theme: "primary", position: "top-right", duration: 1000, className: 'success-toast'
                        }) : self.$toasted.show('Club Deactivated', {
                            theme: "primary", position: "top-right", duration: 1000, className: 'success-toast'
                        });
                        self.statusDialog = false;
                    }
                    else {
                        self.$toasted.show(res.data.message, self.errorToast);
                    }
                })
                .catch((handle) => {
                    self.$toasted.show(handle, self.errorToast);
                })
        },
        changeMobile(val) {
            let self = this;
            let a = val.officer_role;
            let b = Object({
                role: val.officer_role,
                phone: val.phone,
                officer_id: val.officer_id,
                name: val.name
            });
            self.club1.officers[val.officer_role] = b;
            self.$forceUpdate();
        },
        cancelEditClubDialog() {
            let self = this;
            self.dob = null;
            self.editClubDialog = false;
        },

        saveClub() {
            let self = this;
            self.getClubDetails();
            self.addClubDialog = false;
        }
        ,
        cancelClubDialog() {
            let self = this;
            self.addFlag = false;
            self.addClubDialog = false;
        },
        gotoMembers(data, clubId, name) {
            localStorage.setItem('club_details', JSON.stringify(data));
            this.$router.push({path: '/members/' + clubId})
        },
        importClub() {
            let self = this;
            let ele = document.getElementById("fileId");
            ele.value = '';
            self.clubFile = '';
            self.clubFileName = '';
            self.alertDialog = false;
            self.uploadBtnFlag = true;
            self.dialog = true;
        }
        ,
        pickFile() {
            let self = this;
            self.$refs.image.click()
        },
        onFilePicked(e) {
            const files = e.target.files;
            if (files[0] !== undefined) {
                this.clubFileName = files[0].name;
                if (this.clubFileName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener('load', () => {
                    this.clubFile = files[0] // this is an image file that can be sent to server...
                })
            }
            this.uploadBtnFlag = false;
        },
        uploadClub() {
            let self = this;
            self.uploadBtnFlag = true;
            self.uploadProgressPopup = true;
            let formData = new FormData();
            formData.append('file', this.clubFile);
            axios.post(self.constant.apiUrl + 'club/upload/sheet', formData, {headers: self.header})
                .then(res => {
                    self.msg = '';
                    if (res.data.flag) {
                        self.successRecordArr = res.data.data.success;
                        self.failRecordArr = res.data.data.error;
                        self.uploadProgressPopup = false;
                        self.uploadStatusPopup = true;
                        self.getClubDetails();
                        self.dialog = false;
                    } else {
                        self.uploadProgressPopup = false;
                        if (res.data.errors) {
                            self.successRecordArr = [];
                            self.failRecordArr = res.data.errors;
                            self.uploadStatusPopup = true;
                            self.getClubDetails();
                            self.dialog = false;

                        } else if (res.data.data.errors) {
                            self.successRecordArr = [];
                            self.failRecordArr = res.data.data.errors;
                            self.uploadStatusPopup = true;
                            self.getClubDetails();
                            self.dialog = false;

                        } else {
                            self.alertDialog = true;
                            self.msg = res.data.message;
                        }
                    }

                }).catch((handle) => {
                self.uploadProgressPopup = false;
                self.alertDialog = true;
                self.msg = '';
                self.msg = 'Please select a valid file'
            })
        }
        ,
        successUpload() {
            let self = this;
            self.$toasted.show("Uploaded Successfully", self.successToast);
        },
        cancelUpload() {
            let self = this;
            self.dialog = false;
        },

    },
}


// WEBPACK FOOTER //
// ./src/components/Club/MyClubs.js